var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helperMenu"},[_c('button',{on:{"click":function($event){return _vm.showModal('AddPromotionModal')}}},[_c('PlusIcon'),_c('div',{staticClass:"new-btn-label"},[_vm._v("Nowa promocja")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }